<template>
  <main>
    <NavMenu>
      <NavItem name="个人中心" />
      <NavItem name="修改密码" active />
    </NavMenu>
    <section class="content">
      <div class="formarea">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="180px"
          class="demo-ruleForm"
        >
          <el-form-item label="旧密码：" prop="oldPwd">
            <el-input
              type="password"
              v-model="ruleForm.oldPwd"
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPwd">
            <el-input
              type="password"
              v-model="ruleForm.newPwd"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkNewPwd">
            <el-input
              type="password"
              v-model="ruleForm.checkNewPwd"
              placeholder="请再次输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="submit-button"
              type="primary"
              @click="submitForm('ruleForm')"
            >
              保存
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.ruleForm.checkNewPwd !== '') {
          this.$refs.ruleForm.validateField('checkNewPwd')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.ruleForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        ruid: localStorage.getItem('userruid'),
        newPwd: '',
        checkNewPwd: '',
        oldPwd: '',
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newPwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkNewPwd: [{ required: true, validator: validatePass2, trigger: 'blur' }],
      },
    }
  },
  components: {},

  created() {},
  mounted() {},
  methods: {
    // 获取机构类型
    getCustomerType() {
      let url = '/api/v1/platform/DataModel/objectlist'
      let postBody = {
        pageno: 0,
        pagesize: 10,
        type: 'customer_type',
        filter: {
          itemList: [
            {
              fieldName: 'name',
              relationOperator: 'like',
              searchWord: '',
            },
          ],
        },
        field: '',
        order: {
          itemList: [
            {
              asc: true,
              fieldName: 'orderno',
              valueType: 'N',
            },
          ],
        },
      }
      this.$http({
        url: url,
        method: 'POST',
        data: postBody,
      }).then((res) => {
        if (res.cxajaxrc == 0) {
          this.customerTypeData = res.returnvalue.recordlist
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let url = '/api/v1/platform/user/changePwd'
          let postBody = {
            oldPwd: '',
            newPwd: '',
            ruid: '1786dd54013f001',
          }
          postBody = Object.assign(postBody, this.ruleForm)
          this.$http({
            url: url,
            method: 'POST',
            data: postBody,
          }).then((res) => {
            if (res.cxajaxrc == 0) {
              this.$message.success('密码修改成功')
              this.ruleForm = {
                ruid: localStorage.getItem('userruid'),
                newPwd: '',
                checkNewPwd: '',
                oldPwd: '',
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 16px;
}
::v-deep .el-form-item__label {
  font-size: 16px !important;
}
.el-button {
  border-radius: 0px;
  font-size: 16px;
}
::v-deep .el-input__inner {
  border-radius: 0px !important;
  min-height: 42px !important;
  font-size: 16px;
}
main {
  width: 1200px;
  align-self: center;
}
.content {
  min-height: 400px;
  box-shadow: $mainShadow;
  background: #ffffff;
  .tip {
    padding: 30px;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      text-align: left;
      color: #999999;
    }
  }
  .formarea {
    padding-left: 125px;
    padding-right: 400px;
    padding-top: 50px;
  }
}
.submit-button {
  padding: 10px 40px;
}
</style>
